import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { theme } from "src/theme/mui-theme";
import { ts } from "src/utils/translate";
import { CheckmarkIcon } from "src/pages/ProjectDetailsWizard/icons/CheckmarkIcon";
import { FloorFormData } from "src/pages/PlannerPage/FloorWizard/useUpsertFloor";

interface TutorialStepProps {
    formData: FloorFormData;
    setFormData: (data: FloorFormData) => void;
}

export const FloorWizardTutorialStep = ({ formData, setFormData }: TutorialStepProps) => {

    return (
        <>
            <Box marginY={2}>
                <Box
                    sx={{
                        width: "100%",
                        height: 300,
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: theme.palette.grey[400],
                    }}
                >
                    <Typography variant="h6" color={theme.palette.text.primary}>
                        Tutorial GIF or Animation
                    </Typography>
                </Box>
            </Box>

            <FormControlLabel
                label={ ts('do_not_show_again', 'Don\'t show again') }
                control={
                    <Checkbox
                        checked={formData.dontShowAgain}
                        onChange={ (e) => setFormData({ ...formData, dontShowAgain: e.target.checked }) }
                        icon={
                            <Box
                                sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: 1,
                                    border: '2px solid #1976d2',
                                }}
                            />
                        }
                        checkedIcon={
                            <Box
                                sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: 1,
                                    bgcolor: '#1976d2',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <CheckmarkIcon sx={{ fontSize: 16, color: 'white' }} />
                            </Box>
                        }
                    />
                }
            />
        </>
    );
};
